var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.48368 0.415084C9.44888 0.0347085 9.98724 -0.0797236 10.1102 0.281921L11.141 3.31586C12.4722 7.23349 16.3144 9.72864 20.4347 9.35125L23.6256 9.05899C24.006 9.02418 24.1205 9.56254 23.7588 9.68547L20.7248 10.7163C16.8072 12.0475 14.3121 15.8897 14.6895 20.01L14.9817 23.2009C15.0166 23.5813 14.4782 23.6958 14.3553 23.3341L13.3244 20.3001C11.9933 16.3825 8.15107 13.8874 4.03071 14.2648L0.839779 14.5571C0.459404 14.5919 0.344972 14.0535 0.706617 13.9306L3.74055 12.8997C7.65819 11.5686 10.1533 7.72637 9.77594 3.60602L9.48368 0.415084Z",
    fill: "#56BBF1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueStar);
export default __webpack_public_path__ + "static/media/blue-star.ade798db6ebefb33543f6b5a94f0bf93.svg";
export { ForwardRef as ReactComponent };